import React, { Fragment } from "react";
import { currentTab } from "store/blogCategories";

import MainHeadliner from "components/main-headliner";
import Headlines from "components/headlines";

const BlogHeadlines = ({ data }) => {
  const { current, switchTab } = currentTab();

  return (
    <div>
      <div className="container">
        {data.categoryBlogs
          .filter(({ category: { title } }) => title == current)
          .map(({ mainHeadliner, topHeadlines }, index) => (
            <Fragment key={index}>
              <MainHeadliner data={mainHeadliner} />
              <Headlines data={topHeadlines} title={data.title} />
              <div className="h-0.5 w-full bg-gray-300 mb-20 sm:mb-0" />
            </Fragment>
          ))}
      </div>
    </div>
  );
};

export default BlogHeadlines;
